import type { ContractRateCheck, ProgramRateCheck } from "@/api/contract_term"
import { describe_program_rate_check, format_dollars, format_effective_window } from "@/contracts/contract_term_format"
import { FileSignature } from "lucide-react"

interface ContractRateCheckCalloutProps {
  check: ContractRateCheck
  className?: string
}

function ProgramLine({ program }: { program: ProgramRateCheck }) {
  const over = !program.within_tolerance && program.overcharge > 0
  return (
    <div class="text-sm">
      <div class={over ? "font-medium text-red-800" : "text-slate-700"}>{describe_program_rate_check(program)}</div>
      <div class="text-xs text-slate-500">
        {program.program_label} · {program.term_status} term "{program.term_program}",{" "}
        {format_effective_window(program.effective_from, program.effective_to)} · {program.line_count}{" "}
        {program.line_count === 1 ? "line" : "lines"} on {format_dollars(program.basis_total)} sales
      </div>
      {program.source_excerpt && (
        <blockquote class="mt-1 border-l-2 border-slate-300 pl-2 text-xs italic text-slate-500">{program.source_excerpt}</blockquote>
      )}
    </div>
  )
}

/** "Charged 1.30% vs contracted 1.17% — $3.90 over", per program billed on the deduction. */
export function ContractRateCheckCallout({ check, className }: ContractRateCheckCalloutProps) {
  const over = check.total_overcharge > 0
  return (
    <div class={`rounded-lg border px-4 py-3 space-y-2 ${over ? "border-red-200 bg-red-50" : "border-slate-200 bg-slate-50"} ${className ?? ""}`}>
      <div class="flex items-center gap-2 text-sm font-medium text-slate-800">
        <FileSignature className="h-4 w-4 shrink-0 text-slate-600" />
        {over ? `Charged ${format_dollars(check.total_overcharge)} above contracted rates` : "Charged at contracted rates"}
      </div>
      {check.programs.map((program: ProgramRateCheck) => (
        <ProgramLine key={`${program.program_label}-${program.term_id}`} program={program} />
      ))}
    </div>
  )
}
